module.exports = __webpack_public_path__ + "img/color.d5f3448b.png";